export function Songs() {
  return (
    <div>
      <h1 className="text-3xl font-bold">Songs</h1>
    </div>
  );
}

